export default "__VITE_ASSET__aa2ad45c__"